import React from "react";

export default function Registration() {
  return (
    <div>
      <hr className="top-margin" />
      {/* <!--/NavBar--> */}

      <div className="about" style={{ marginTop: "7rem" }}>
        <div className="card border-primary mb-3" style={{ width: "auto" }}>
          <div className="card-body">
            <h5 className="card-title text-primary">REGISTRATION</h5>
            <h6 className="card-subtitle mb-2 text-muted">&nbsp;</h6>
            <div className="reg_cont">
              <p className="card-text " style={{ textAlign: "center" }}>
                Registration is mandatory for at least one author of an accepted
                paper to register in order for the paper to appear in the
                proceedings, technical presentation and included in the journal
                publication.
              </p>
            </div>

            {/* <!--TABLE--> */}
            <div className="about">
              <div className="card border-0 mb-10" style={{ width: "auto" }}>
                <div className="card-body">
                  <h5 className="card-title text-primary">FEE DETAILS</h5>
                  <h6 className="card-subtitle mb-2 text-muted">&nbsp;</h6>
                  <div id="table">
                    <table className="table table-hover">
                      <tbody className="table-bordered border-primary">
                        <tr>
                          <th scope="col">CATEGORY</th>
                          <th scope="col">FEE</th>
                        </tr>
                        <tr>
                          <td>
                            <span style={{ fontWeight: "bold" }}>* </span>
                            Students/Faculty Members/Research Scholars (India)
                          </td>
                          <td>INR 1000</td>
                        </tr>
                        <tr>
                          <td>For Foreign Authors</td>
                          <td>USD 100</td>
                        </tr>
                        <tr>
                          <td>
                            Listeners (without Paper Presentation & Publication)
                          </td>
                          <td>INR 500</td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="reg_cont">
                      <p
                        className="card-text "
                        style={{ textAlign: "center", fontWeight: "bold" }}
                      >
                        * Rs.2000 to be paid for scopus indexing
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <!--/TABLE--> */}

            <div className="reg_cont">
              <p className="card-text" style={{ textAlign: "center" }}>
                After receiving the acceptance intimation, the participants can
                pay the required amount either by DD in favor of “Kongunadu
                College of Engineering and Technology” payable at Namakkal or
                through Net banking.
              </p>
            </div>

            {/* <!--REGISTRATION TABLE--> */}
            <div className="about">
              <div className="card border-0 mb-10" style={{ width: "auto" }}>
                <div className="card-body">
                  <h5 className="card-title text-primary">BANK DETAILS</h5>
                  <h6 className="card-subtitle mb-2 text-muted">&nbsp;</h6>
                  <div id="reg_table">
                    <table className="table table-hover">
                      <tbody className="table-bordered border-primary">
                        <tr>
                          <td>Name </td>
                          <td>
                            The Principal, Kongunadu College of Engg., &
                            Technology
                          </td>
                        </tr>
                        <tr>
                          <td>Account Number </td>
                          <td>6098615995</td>
                        </tr>
                        <tr>
                          <td>Account Type</td>
                          <td>SB</td>
                        </tr>
                        <tr>
                          <td>IFSC </td>
                          <td>IDIB000M120</td>
                        </tr>
                        <tr>
                          <td>MICR No</td>
                          <td>620019026</td>
                        </tr>
                        <tr>
                          <td>Bank </td>
                          <td>Indian Bank</td>
                        </tr>
                        <tr>
                          <td>Branch</td>
                          <td>MEIAKKALNAICKENPATTI</td>
                        </tr>
                        <tr>
                          <td>Branch Code </td>
                          <td>01208</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            {/* <!--/REGISTRATION TABLE--> */}

            <div className="reg_cont">
              <p className="card-text" style={{ textAlign: "center" }}>
                Participants can pay their registration fee any time before 10
                October 2021 to confirm their participation through DD or online
                payment.
              </p>
            </div>
            <br />
            <hr />
            <div className="note">
              <p>
                <strong>Note : </strong>
                <ol>
                  Scanned copy of the transaction receipt should be revert back
                  to the conference mail by mentioning the paper id, title and
                  author name. Your transaction will not be accepted without the
                  scanned copy of receipt.
                </ol>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
